// src/infra/backoffice/revenue-report/useRevenueReportApi.ts
import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { IBackofficeRevenueReport } from "../../../application/states/backoffice/revenue-report"

export const useBackofficeRevenueReportApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const getRevenueReportApi = useCallback(async (data: { date: Date }): Promise<IBackofficeRevenueReport[]> => {
    // extrai só o dia
    const reportMonth = data.date.toISOString().split('T')[0]  // ex: "2025-05-01"
    try {
      const response = await axiosAuthInstance.get('/routes/subscription/reportrecipe/global-revenue-report', {
        params: { reportMonth }
      })
      const result = response.data
      if (!result) throw new Error('Erro ao buscar relatório global')
      return result
    } catch (error: any) {
      // Se for erro 404, retorna array vazio (sem dados)
      if (error?.response?.status === 404) {
        return []
      }
      // Para outros erros, re-throw
      throw error
    }
  }, [axiosAuthInstance])

  const getResaleRevenueReportApi = useCallback(async (data: {
    date: Date,
    resellerId: string
  }): Promise<IBackofficeRevenueReport[]> => {
    const reportMonth = data.date.toISOString().split('T')[0]
    try {
      const response = await axiosAuthInstance.get('/routes/subscription/reportrecipe/reseller-revenue-report', {
        params: { reportMonth, resellerId: data.resellerId }
      })
      const result = response.data
      if (!result) throw new Error('Erro ao buscar relatório de revenda')
      return result
    } catch (error: any) {
      // Se for erro 404, retorna array vazio (sem dados)
      if (error?.response?.status === 404) {
        return []
      }
      // Para outros erros, re-throw
      throw error
    }
  }, [axiosAuthInstance])

  const forceGenerateRevenueReportApi = useCallback(async (): Promise<void> => {
    await axiosAuthInstance.post('/routes/subscription/reportrecipe/generate-monthly-report')
  }, [axiosAuthInstance])

  return {
    getRevenueReportApi,
    getResaleRevenueReportApi,
    forceGenerateRevenueReportApi
  }
}
